import ApiService from '@/services/api.service'

const CitiesService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/Cities/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    },  
    
    getCities(parameter){
         const requestData = {
            method: 'get',
            url: "/Cities/",       
            params: {
            AreaRecId:parameter.AreaRecId 
            }
          }       
          return ApiService.customRequest(requestData);
    },

    Add(data){
        return ApiService.post(`/Cities`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/Cities/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/Cities/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/Cities/${Id}`);
    }
  }


  
  export default CitiesService;